/**
 * Main js for DLF Theme
 * Jonas Stensved 2016
 */

(($ => {
    
    class SearchResultLoader 
    {

        constructor($el) {    
            this.$el = $el;
            this.$target = $el.closest('#content').find('.content-holder');
            this.terms = $el.data('search-terms');
            this.paged = parseInt($el.data('search-paged'), 10);
            this.postType = $el.data('search-post-type-filter');
             
            if (this.$target.length == 0) {
                throw `Target ${$el.data('content-box-type')} not found.`;
            } 
            
            this.bind(); 
        }
        
        bind() {
            
            let thisref = this;
            
            this.$el.on('click', event => {               
            
                event.preventDefault();
                thisref.fetch();      
               
                // Add a page to count
                thisref.paged += 1;
                
            });
            
        }
        
        fetch() {
            
            let thisref = this;
            
            // Disable
            thisref.$el.attr('disabled', true);
            
            $.post(ajax_object.ajax_url, {
                action: 'get_search_results',
                type: thisref.type,
                paged: thisref.paged,
                post_type: thisref.postType,
                s: thisref.terms
            }, data => {
                
                // Hide if empty
                if (data === ''){
                    thisref.$el.hide();
                    return;
                }
                
                // Add data to row
                thisref.$target.append(data);
                
                // Enable
                thisref.$el.attr('disabled', false);
                
                // todo: handle error
                
                
            });            
            
        }
        
    }
    
    
    /**
     * Autoload for all elements with data-content-box-loader attribute, ex <a data-content-box-loader data-content-box-target="#targetId">Load more</a>
     * Requires data-content-box-target to be set
     */
    $('a[data-search-result-loader]').each((ix, el) => {
        
        // Create instance and save on element for ref
        const $el = $(el);
        $el.data('searchResultLoader', new SearchResultLoader($el));
        
    });
    
    
    
}))(jQuery)